<template xmlns="http://www.w3.org/1999/xhtml">
  <div>
    <BaseImage title="Blog" />
    <div class="container-fluid">
      <div class="row py-4">
        <div class="col-lg-3 col-12 border p-5">
          <BlogNav />
        </div>
        <div class="col-lg-7 col-12 border p-5">
          <BlogContent />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BaseImage from "@/components/BaseImage";
import BlogContent from "@/components/Blog/BlogContent";
import BlogNav from "@/components/Blog/BlogNav";
export default {
  components: { BlogNav, BlogContent, BaseImage, },
};
</script>

<style scoped></style>
